module.exports = __webpack_public_path__ + "img/logo.81e1f57a.png";